export const BooleanFormatter = ({ trueValue = 'Yes', falseValue = 'No', value }) => {
  return value === true ? trueValue : falseValue
}
